import {
    FormControl,
    FormHelperText,
    InputLabel,
    MenuItem,
    Select,
    SelectChangeEvent,
} from "@mui/material"
import { observer } from "mobx-react"
import { t } from "@lingui/macro"
import { useCallback, useMemo } from "react"

import { useStore } from "src/store/lib/useStore"
import { KnowledgeItemStore } from "src/modals/knowledge-items/store"
import { knowledgebase_KnowledgeItemType } from "src/api"
import { KNOWLEDGE_TYPES } from "src/shared/knowledge-base/constants"

export const KnowledgeItemsType = observer(() => {
    const store = useStore(KnowledgeItemStore)
    const accessType = store.formFields.get("access_type")
    const type = store.formFields.get("knowledge_item_type")
    const error = store.formFields.error("knowledge_item_type")

    const handleChange = useCallback(
        (event: SelectChangeEvent) => {
            store.formFields.set(
                "knowledge_item_type",
                event.target.value as knowledgebase_KnowledgeItemType,
            )
        },
        [store.formFields],
    )

    const isDisabled = useMemo(() => accessType === "READ", [accessType])
    const hasError = useMemo(() => Boolean(error), [error])

    return (
        <FormControl sx={{ breakInside: "avoid" }}>
            <InputLabel id="type-label">
                {t`knowledge-item-modal.type`}
            </InputLabel>
            <Select
                labelId="type-label"
                id="type"
                value={type}
                label={t`knowledge-item-modal.type`}
                onChange={handleChange}
                error={hasError}
                disabled={isDisabled}
            >
                {KNOWLEDGE_TYPES.map(({ value, label }) => (
                    <MenuItem key={value} value={value}>
                        {label}
                    </MenuItem>
                ))}
            </Select>
            {hasError && <FormHelperText error>{error}</FormHelperText>}
        </FormControl>
    )
})
